/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const t=e=>{const n=e.shadowRoot,c=e.contentDocument;return n&&n.activeElement?t(n.activeElement):c&&c.activeElement?t(c.activeElement):e},i=e=>{if(!(!e||!e.activeElement))return t(e.activeElement)};exports.getActiveElement=i;exports.getInnerActiveElement=t;
